import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelText as _vModelText, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "block" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "checkbox" }
const _hoisted_4 = ["value"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 0,
  class: "block-body vertical mt-16"
}
const _hoisted_7 = { class: "block-list vertical" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "block-item" }
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", {
      class: "block-desc",
      innerHTML: _ctx.text
    }, null, 8, _hoisted_2),
    _createElementVNode("div", {
      class: _normalizeClass(["block-body", _ctx.verticalLayout ? 'vertical' : 'horizontal'])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.answerChunk, (answer) => {
        return (_openBlock(), _createElementBlock("ul", {
          key: answer,
          class: _normalizeClass(["block-list", {
          vertical: _ctx.verticalLayout,
          horizontal: !_ctx.verticalLayout,
          center: answer.length === _ctx.centerNum,
        }])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(answer, (choiceItem) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "block-item",
              key: choiceItem.order
            }, [
              _createElementVNode("label", _hoisted_3, [
                _withDirectives(_createElementVNode("input", {
                  value: choiceItem,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.checkbox) = $event)),
                  type: "checkbox",
                  class: "checkbox__input"
                }, null, 8, _hoisted_4), [
                  [_vModelCheckbox, _ctx.checkbox]
                ]),
                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "checkbox__shape" }, null, -1)),
                _createElementVNode("p", {
                  class: "checkbox__title",
                  innerHTML: 
                _ctx.currentLang === 'RU' ? choiceItem.choiceRu : choiceItem.choiceKk
              
                }, null, 8, _hoisted_5)
              ])
            ]))
          }), 128))
        ], 2))
      }), 128))
    ], 2),
    (_ctx.customAnswer === true)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("ul", _hoisted_7, [
            _createElementVNode("p", {
              class: "radio__title-box",
              innerHTML: 
            _ctx.customTextAnswer !== null
              ? _ctx.customTextAnswer
              : _ctx.currentLang === 'RU'
              ? 'Свой вариант ответа'
              : 'Сіздің жауап нұсқаңыз'
          
            }, null, 8, _hoisted_8),
            _createElementVNode("li", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.customAnswerS) = $event)),
                placeholder: 
              _ctx.currentLang === 'RU' ? 'Ваш ответ' : 'Сіздің жауабыңыз'
            ,
                class: "input"
              }, null, 8, _hoisted_10), [
                [_vModelText, _ctx.customAnswerS]
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.type === 'ONE_PAGE')
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 1,
          style: {"margin":"16px 0 8px 0"},
          class: _normalizeClass({
        'is-disabled': _ctx.checkbox.length === 0 && _ctx.customAnswerS.length === 0,
      }),
          disabled: _ctx.checkbox.length === 0 && _ctx.customAnswerS.length === 0,
          onClick: _ctx.sendAnswer
        }, {
          default: _withCtx(() => [
            (_ctx.currentLang === 'KK')
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Жіберу"))
              : (_openBlock(), _createElementBlock("span", _hoisted_12, "Отправить"))
          ]),
          _: 1
        }, 8, ["class", "disabled", "onClick"]))
      : _createCommentVNode("", true)
  ]))
}